import React from "react";
import { motion } from "framer-motion";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_6da83eb0-282e-4b37-83ca-c1eb95a3f9df/artifacts/ziykel8w_Contemporary%20Logo%20for%20Charis%20%26%20Mettle%20-%20Design%201.png";

export const FIRM = {
  name: "Charis & Mettle",
  tagline: "Built on trust. Driven by outcomes.",
  offices: [
    {
      city: "Lagos",
      country: "Nigeria",
      address: "H.18, Ocean Garden Estate, KM 33, Lekki-Epe Expressway, Eko Akete, Lagos",
      addressLines: [
        "H.18, Ocean Garden Estate",
        "KM 33, Lekki-Epe Expressway",
        "Eko Akete, Lagos",
      ],
      phone: "+234 803 650 7444",
    },
  ],
  address: "H.18, Ocean Garden Estate, KM 33, Lekki-Epe Expressway, Eko Akete, Lagos",
  phone: "+234 803 650 7444",
  email: "info@charis-mettle.com",
  social: {
    linkedin: "#",
    instagram: "#",
    twitter: "#",
    facebook: "#",
  },
};

// Single source of truth for services (used in Header nav footer + marquee + practice cards)
export const SERVICES = [
  "Mergers & Acquisitions",
  "Private Equity",
  "Commercial Transactions",
  "Regulatory Compliance",
  "Corporate Governance Frameworks",
];

export function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`inline-block text-[11px] uppercase tracking-[0.28em] text-sage-600 font-sans ${className}`}
    >
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, intro, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-charcoal mt-4 leading-[1.05]">
        {title}
      </h2>
      {intro && (
        <p className="mt-6 text-base sm:text-lg text-charcoal-muted font-sans leading-relaxed max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
}

// Framer-motion scroll reveal — elegant rise-and-settle entrance, fires once
export function Reveal({
  as = "div",
  children,
  delay = 0,
  y = 28,
  className = "",
  ...props
}) {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -60px 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...props}
    >
      {children}
    </M>
  );
}

export function PrimaryButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center gap-3 bg-sage-600 text-cream-50 hover:bg-sage-700 px-7 py-4 font-sans text-[12px] uppercase tracking-[0.22em] transition-colors duration-300 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center gap-3 bg-transparent border border-sage-600 text-charcoal hover:bg-sage-600 hover:text-cream-50 px-7 py-4 font-sans text-[12px] uppercase tracking-[0.22em] transition-colors duration-300 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
